"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApi = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@jsmodules/core");
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var config_1 = require("@shared/config");
var HttpFactory = core_1.http.HttpFactory;
function getApi(configName) {
    var baseUrl = config_1.apiHosts[configName];
    if (!baseUrl) {
        throw new Error("api:未配置接口->" + configName);
    }
    return di_1.default.getInstance(HttpFactory, [baseUrl]);
}
exports.getApi = getApi;
exports.default = getApi;
